// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","surface":"surface_ii69n","bar":"bar_tI_KK","flush":"flush_c7bHs"};